module.exports = __webpack_public_path__ + "img/img-auth-m.5a6cbc9c.png";